import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { SuccessTag } from '../SuccessTag/SuccessTag'
import { AccountAvatar } from 'components/PostPreviewModalV2/components/AccountToggle/AccountAvatar'
import { MetaAdsInstagramAccount } from '../Types'

export const InstagramAccountCard = ({
  account,
  isSelected,
  onSelect,
}: {
  account: MetaAdsInstagramAccount
  isSelected: boolean
  onSelect: () => void
}) => {
  const additionalData = account.additional_data ?? {}
  const followerCount = additionalData.followers_count ?? 0

  return (
    <div className={Styles.card}>
      <div className={Styles.cardLeft}>
        <input
          type="radio"
          name="instagramAccount"
          value={account.provider_id}
          checked={isSelected}
          onChange={onSelect}
          aria-label={`Select Instagram Account ${account.name}`}
          className={Styles.radioInput}
        />
        <AccountAvatar account={account} />
        <div className={Styles.accountInfo}>
          <Text variant="primary" fontWeight="600">
            {account.name}
          </Text>

          <Text variant="secondary">
            <div className={Styles.secondaryAccountInfo}>
              {followerCount} Followers ID: {account.provider_id}
            </div>
          </Text>
        </div>
      </div>
      <div className={Styles.cardRight}>
        {isSelected ? (
          <SuccessTag text="Selected" />
        ) : (
          <Button variant="ghost" size="sm" onPress={onSelect}>
            Use This Account
          </Button>
        )}
      </div>
    </div>
  )
}
